"use client"

import type React from "react"

import { useState } from "react"
import Image from "next/image"

export default function NewsletterForm({ formspreeId }: { formspreeId: string }) {
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [isSuccess, setIsSuccess] = useState(false)
  const [isError, setIsError] = useState(false)

  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault()
    setIsSubmitting(true)
    setIsError(false)

    try {
      const formData = new FormData(event.currentTarget)
      const response = await fetch(`https://formspree.io/f/${formspreeId}`, {
        method: "POST",
        body: formData,
        headers: {
          Accept: "application/json",
        },
      })

      if (response.ok) {
        setIsSuccess(true)
      } else {
        setIsError(true)
        console.error("Form submission failed")
      }
    } catch (error) {
      setIsError(true)
      console.error("Form submission error:", error)
    } finally {
      setIsSubmitting(false)
    }
  }
  

  return (
    <div className="bb-se-f kkfd-e hjfdncs vvv-pppf-r">
      <Image
        width={100}
        height={82}
        loading="lazy"
        alt=""
        className="image-73"
        src="/webflow-assets/images/fg-e-1s.svg"
      />
      <Image
        width={100}
        height={82}
        loading="lazy"
        alt=""
        className="image-74"
        src="/webflow-assets/images/fg-e-2s.svg"
      />
      <div className="vf-kk-rt ghjnj">
        Subscribe to our <span className="blue">newsletter </span>
      </div>
      <Image
        width={40}
        height={40}
        loading="lazy"
        alt=""
        className="image-75 none--imm"
        src="/webflow-assets/images/ava-gg-rrt.png"
      />

      <a
        href="https://www.skool.com/listkit"
        target="_blank"
        className="jh-r-c link-param butto--nonej w-inline-block"
        rel="noreferrer"
      >
        <div>Join</div>
        <Image width={24} height={24} loading="lazy" alt="" src="/webflow-assets/images/add-group-users.svg" />
      </a>

      <div className="w-form">
        {!isSuccess ? (
          <form
            id="wf-form-Email-Form-Subscribe-Newsletter"
            name="wf-form-Email-Form-Subscribe-Newsletter"
            onSubmit={handleSubmit}
            className="ff--r--ccd"
          >
            <div className="ki--vvfe niokddd">No spam, only useful information.</div>
            <div className="flex--inp">
              <input
                className="hjcs w-input"
                maxLength={256}
                name="Email-Newsletter"
                placeholder="Email"
                type="email"
                id="Email-Newsletter"
                required
              />
              <Image
                width={24}
                height={24}
                loading="lazy"
                alt=""
                className="ab-imm"
                src="/webflow-assets/images/ncksxa.svg"
              />
            </div>
            <button type="submit" className="butt--subsc w-button" id="submit-button" disabled={isSubmitting}>
              {isSubmitting ? "Please wait..." : "Subscribe"}
            </button>
          </form>
        ) : null}
        {isSuccess && (
            <div className={`fff-oo-t-tr w-form-done`} style={{ display: isSuccess ? "flex" : "none" }} id="success-message" tabIndex={-1}>
                <div>Thank you! Your submission has been received!</div>
            </div>
        )}
        {isError && (
            <div className={`w-form-fail`} id="error-message" tabIndex={-1}>
                <div>Oops! Something went wrong while submitting the form.</div>
            </div>
        )}
      </div>
    </div>
  )
}
